module.exports = __webpack_public_path__ + "img/bnk.e6219258.png";